import React from 'react';
import {useNavigate} from 'react-router-dom';
/* A function that returns a JSX element. */
/* Returning a div with a className of iconCarrito and an onClick event that calls the goToCarrito
function. */
export const IconoMensajes = (props) => {
	/* A hook that allows to navigate between routes. */
	const navigate = useNavigate();

	/* Destructuring the props object. */
	const {numMensajes, goToMensajes} = props;
	/* Returning a div with a className of iconoMensajes and an onClick event that calls the
    goToMensajes function. */
	return (
		<>
			<div
				className='iconCarrito'
				onClick={goToMensajes}
			>
				<div className=''>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='21'
						height='21'
						fill='currentColor'
						className='bi bi-chat-right-text'
						viewBox='0 0 16 16'
					>
						<path d='M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z' />
						<path d='M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z' />
					</svg>
				</div>
				{numMensajes >= 1 && (
					<div className='alertIconHeader'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='17'
							height='17'
							fill='currentColor'
							className='bi bi-exclamation-circle-fill'
							viewBox='0 0 16 16'
						>
							<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z' />
						</svg>
					</div>
				)}
			</div>
		</>
	);
};
